import React from 'react'
import moment from 'moment'
import { DatePicker, Select, Button } from 'antd'

const { Option } = Select

export default function DeliveryTimePanel({
  deliveryDaysMin,
  deliveryDaysMax,
  deliveryTimes,
  onTimeChange,
  onDateChange,
  deliveryDateRequired,
  deliveryDateRequiredErrorBox,
  setDeliveryDateRequiredErrorBox
}) {
  // カレンダーで選択できない日付の設定
  const disabledDate = current => {
    // 範囲外である
    const isOutOfRange = 
      current < moment().add(deliveryDaysMin - 1, 'days') ||
      current > moment().add(deliveryDaysMax, 'days');

    // 期間内である
    const isHolidayRange = current.isBetween(
      '2026-01-02',
      '2026-01-05',
      'day', // 比較の粒度
      '[]'   // 開始日( [ )と終了日( ] )を含む
    );

    return isOutOfRange || isHolidayRange;

  }

  return (
    <div className="panel mb-2">
      <div className="mb-2">
        {deliveryDateRequired ? '' :
          <div className="mb-1">
            <p className="text-red">
              最短でのお届け希望の場合は、日付を選択しないでください。
            </p>
          </div>
        }
        <div className="mb-1">
          <p>お届け希望日{deliveryDateRequired ? <span className="text-red">※必須</span> : ''}</p>
          {deliveryDateRequired ? <p><span className="text-blue">※土日祝日は出荷がないため、ご注文は休日明けの出荷になります。</span></p> : ''}
        </div>
        <div className="mb-1">
          <DatePicker
            disabledDate={disabledDate}
            style={{ width: "100%" }}
            onChange={(p) => onDateChange(p ? p.format('YYYY-MM-DD') : null)}
          />
        </div>
        {deliveryDateRequiredErrorBox && (
          <DeliveryDateRequiredErrorBox onOk={() => setDeliveryDateRequiredErrorBox(false)} />
        )}
      </div>
      <div className="mb-1">
        <div className="mb-1">
          <p>お届け希望時間</p>
        </div>
        <div className="mb-1">
          <Select
            style={{ width: "100%" }}
            onChange={(p) => onTimeChange(p)}
            defaultValue={deliveryTimes[0].id}
          >
            {deliveryTimes ?
              deliveryTimes.map((time) => (
                <Option key={time.id} value={time.id}>{time.range}</Option>
              )) : ''
            }
          </Select>
        </div>
      </div>
    </div>
  )
}

function DeliveryDateRequiredErrorBox({ onOk }) {
  return (
    <div className="mb-2">
      <div className="message is-danger">
        <p className="mb-2">
          お届け希望日は必須入力です。<br />日付を選択してください。
        </p>
        <div className="text-right">
          <Button type="danger" onClick={onOk} ghost>OK</Button>
        </div>
      </div>
    </div>
  )
}